import React from 'react';
export function TrophyIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14v3h3v4.912a2 2 0 01-1.029 1.748l-3.903 2.168A6.983 6.983 0 0113 15.93V20h6v2H5v-2h6v-4.07a6.983 6.983 0 01-4.068-2.101L3.029 11.66A2 2 0 012 9.912V5h3V2zm2 2h10v5A5 5 0 017 9V4zm11.825 6.565L20 9.912V7h-1v2c0 .538-.06 1.062-.175 1.565zM5 9c0 .538.06 1.062.176 1.565L4 9.912V7h1v2z"
  }));
}